import { Field } from 'formik';
import { Input, FormControl } from '@chakra-ui/react';
import ElementInstructions from './components/ElementInstructions';
import ElementHeading from './components/ElementHeading';
import ElementErrorMessage from './components/ElementErrorMessage';
import { transformRSPhone } from '../formControllers/Transformation/Utils.js';
import InputWrapper from './components/InputWrapper';

const Phone = ({ fieldName, qObj, jobSeekerData, handlers, props, index }) => {
  return (
    <Field name={fieldName}>
      {({ field, form }) => (
        <FormControl
          isInvalid={form.errors[fieldName] && form.touched[fieldName]}
        >
          <ElementHeading qObj={qObj} props={props} />
          <ElementInstructions instructions={qObj.instructions} />
          <InputWrapper>
            <Input
              {...field}
              onChange={e =>
                transformRSPhone(e, jobSeekerData, index, qObj, handlers, props)
              }
            />
          </InputWrapper>
          <ElementErrorMessage form={form} index={qObj.index} qid={qObj.qid} />
        </FormControl>
      )}
    </Field>
  );
};

export default Phone;
/*



 */
